import styled from "styled-components"

type SpacerProps = {
    height: string
}
export const Spacer = styled.div<SpacerProps>`
    margin: auto;
    height: ${p => p.height}
`